import { render, staticRenderFns } from "./All.vue?vue&type=template&id=5645d6f9&scoped=true&"
import script from "./All.vue?vue&type=script&lang=js&"
export * from "./All.vue?vue&type=script&lang=js&"
import style0 from "./All.vue?vue&type=style&index=0&id=5645d6f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5645d6f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5645d6f9')) {
      api.createRecord('5645d6f9', component.options)
    } else {
      api.reload('5645d6f9', component.options)
    }
    module.hot.accept("./All.vue?vue&type=template&id=5645d6f9&scoped=true&", function () {
      api.rerender('5645d6f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ispforum/forum/All.vue"
export default component.exports